import axios from "axios";
import { setGlobalState } from "./state";
import { isEmpty } from "./validation";

export const ws = async (method, url, params, data, token) => {
  if (!method || !url) {
    console.error("Internal Server Error");
    return;
  }

  let headers = {};

  if (token) {
    if (isEmpty(localStorage.getItem("accessToken"))) {
      localStorage.clear();
      window.location.replace("/login");
      gestioneSnackbar(true, "Esegui il login", "error");
      return { error: true, data: { message: "Esegui il login!" } };
    } else {
      headers.Authorization = "Bearer " + localStorage.getItem("accessToken");
    }
  }

  const result = new Promise((resolve, reject) => {
    axios({
      method,
      url,
      params,
      data,
      headers,
      responseType: "json",
    })
      .then((res) => {
        resolve({ data: res.data, status: res.status });
      })
      .catch((err) => {
        console.log(err.response?.data ? err.response.data : err.message);
        reject({
          data: err.response?.data,
          status: err.response?.status,
        });
      });
  });

  let apiResponse = {};

  await result
    .then((res) => {
      apiResponse = { error: false, ...res };
    })
    .catch((err) => {
      apiResponse = { error: true, ...err };
    });

  if (apiResponse.status === 401) {
    localStorage.clear();
    window.location.replace("/login");
    gestioneSnackbar(true, "Sessione scaduta!", "error");
  }

  if (apiResponse.status === 403) {
    window.location.replace("/");
    gestioneSnackbar(true, "Non hai i permessi!", "error");
  }

  return apiResponse;
};

export const gestioneSnackbar = (open, message, type) => {
  //Da togliere in ambiente di produzione
  console.log("Messaggio risposta server: " + message.toString());

  setGlobalState("message", message);
  setGlobalState("type", type);
  setGlobalState("open", open);
  return;
};
